// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 0.8em;\n}\n.revico-widget .revico-community-talk-disabled {\n  opacity: var(--disabled-input-opacity);\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
